import { reactive } from 'vue';
import { useApi, getHttpInstance, getApiConfig } from './useApi';
import { useAuth } from './useAuth';
const adminState = reactive({
    factoids: [],
    factoidLoading: false,
    factoidError: null,
    sources: [],
    sourcesLoading: false,
    sourcesError: null,
    employers: [],
    employersLoading: false,
    employersError: null,
    customers: [],
    customersLoading: false,
    customersError: null,
    categories: [],
    categoriesLoading: false,
    categoriesError: null,
    guides: [],
    guidesLoading: false,
    guidesError: null,
    faqs: [],
    faqLoading: false,
    faqError: null,
    selfId: null,
});
let authInitialised = false;
function initAdmin() {
    if (!authInitialised) {
        useAuth();
        authInitialised = true;
    }
    return useApi();
}
function getApi() {
    return getApiConfig().api;
}
function http() {
    return getHttpInstance();
}
function adminGet(url, onSuccess = null) {
    const api = initAdmin();
    url = url.replace(/\/+$/, '');
    if (!url.includes(getApi())) {
        url = getApi() + url;
    }
    http().get(url)
        .then((result) => {
        if (onSuccess)
            onSuccess(result.data);
    })
        .catch((result) => {
        if (result.response && result.response.status == 401) {
            api.refreshLogin(() => {
                adminGet(url, onSuccess);
            });
        }
    });
}
function adminDelete(url, onSuccess = null) {
    const api = initAdmin();
    url = url.replace(/\/+$/, '');
    if (!url.includes(getApi())) {
        url = getApi() + url;
    }
    http().delete(url)
        .then((result) => {
        if (onSuccess)
            onSuccess(result.data);
    })
        .catch((result) => {
        if (result.response && result.response.status == 401) {
            api.refreshLogin(() => {
                adminDelete(url, onSuccess);
            });
        }
    });
}
function adminPost(url, data = null, onSuccess = null, onError = null) {
    http().post(getApi() + url, data)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error:', error);
        if (onError)
            onError(error.message || 'Request failed');
    });
}
function adminPut(url, data = null, onSuccess = null, onError = null, config = null) {
    const args = [getApi() + url, data];
    if (config)
        args.push(config);
    http().put(...args)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error:', error);
        if (onError)
            onError(error.message || 'Request failed');
    });
}
export { adminState, initAdmin, getApi, http, adminGet, adminDelete, adminPost, adminPut };
